/**
 * Velora Modern: the house look (ADR-0007), the modern inverted-L shell,
 * Velora's own wording and keys. Owner: WP0-SHELL. Loaded eagerly; it is
 * the fallback for every layer.
 */
import { tokens } from '@velora/tokens/skins/velora';
import { keymap } from '../shortcuts/keymaps/velora.js';
import type { SkinDefinition } from './types.js';

export const skin: SkinDefinition = {
  id: 'velora',
  layout: 'modern',
  tokens,
  terms: {},
  keymap,
  clinicalPreset: 'velora',
  slots: {},
};
